import { render, staticRenderFns } from "./support-recaptcha.vue?vue&type=template&id=613c7ae6&"
import script from "./support-recaptcha.vue?vue&type=script&lang=js&"
export * from "./support-recaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports